/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

/**
 * Duration of organisation building access, measured from invitation submission.
 */
export type OrganisationAccessPeriodType =
    (typeof OrganisationAccessPeriodType)[keyof typeof OrganisationAccessPeriodType];

export const OrganisationAccessPeriodType = {
    Ongoing: 1,
    TwentyFourHours: 2,
    SevenDays: 3,
    ThirtyDays: 4,
    CustomDays: 5,
} as const;
